/**
 * `useExpandedCoordinates` arrives from URL params as a string, so a truthiness
 * check would treat `'false'` as expanded. Match `true` / `'true'` explicitly.
 */
export const isExpandedCoordinatesSearch = (
  value: boolean | string | undefined,
): boolean => value === true || value === 'true'
